import { render, staticRenderFns } from "./ProjectPhoto.vue?vue&type=template&id=2ffed2ac&scoped=true"
import script from "./ProjectPhoto.vue?vue&type=script&lang=ts"
export * from "./ProjectPhoto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffed2ac",
  null
  
)

export default component.exports